var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"e-btn",class:{ 'e-btn-primary': this.primary },on:{"click":_vm.openLogin}},[_c('e-icon',{attrs:{"icon":"ac-google"}}),_vm._v(" Sign in with Google ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }